@if (serviceId) {
    <app-card [title]="'database.basicInfo.title'" titleSize="large">
        <ng-template #content>
            <app-service-basic-info-form
                [serviceId]="serviceId"
                [form]="form"
                (createEvent)="submit(true)"
                (updateEvent)="submit(false)"
            ></app-service-basic-info-form>

            <app-table
                #serviceBasicInfosTable
                [gridData]="$any(store.data.serviceBasicInfos$ | async)"
                [columns]="columns"
                translatePrefix="service.basicInfo.basicInfo."
                (detailCallback)="detail($event)"
                (deleteCallbackWithEvent)="delete($event)"
                [showDelete]="((store.data.serviceBasicInfos$ | async)?.['items']?.length)"
                [hideCheckboxes]="true"
                [additionalFilter]="basicInfosAdditionalFilter"
                [refreshCallback]="store.api.getServiceBasicInfos"
                [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
            ></app-table>
        </ng-template>
    </app-card>
}
